<template>
  <div style="width: 100%; margin-left: -10px">
    <div :class="[info_content == null || info_content == '' ? 'data-table-list-comment nocomment' : 'data-table-list-comment']" @click="activeComment(info_content)" v-if="!input_show">
      <pre style="margin: 0" v-if="permission.access">{{ info_content == null || info_content == "" ? "入力" : info_content }}</pre>
      <div style="margin: 0" v-else><font-awesome-icon :icon="['fas', 'lock']"/></div>
    </div>
    <div class="flex-row" style="width:240px" v-if="input_show">
      <input
        v-model="value"
        class="comment-textarea"
        :id="id + '-' + property_id"
        @keydown.enter.ctrl.exact="changeInfo()"
        @keydown.enter.meta.exact="changeInfo()"
        @keypress.enter="changeInfo()"
        @change="comment_on ? '' : changeInfo()"
        @blur="comment_on ? '' : changeInfo()"
      >
      <!-- <i class="el-icon-circle-close pointer" style="margin-left: 5px; font-size: 14px; color: #aaa" @click="input_show = false"></i> -->
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const createInfoAPI = root + "/api/note/create_info";

export default {
  name: "noteInfo",
  props: ["sns_type", "property_id", "property", "info_content", "id"],
  data() {
    return {
      input_show: false,
      comment_on: false,
      comment_before: "",
      value: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.personal_data;
    },
    textarea_rows() {
      if (this.value) {
        var num = this.value.match(/\r\n|\n/g);
        return num > 6 ? 7 : num > 3 ? num : 3;
      } else {
        return 3;
      }
    },
  },
  methods: {
    activeComment(comment) {
      if (this.permission.edit) {
        var target = this.id + "-" + this.property_id;
        this.input_show = true;
        this.comment_before = comment;
        this.value = comment;
        setTimeout(() => {
          document.getElementById(target).focus();
        }, 50);
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    changeInfo() {
      if (this.permission.edit) {
        this.comment_on = true;
        this.input_show = false;
        if (this.comment_before != this.value) {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("influencer", this.id);
          params.append("sns_type", this.sns_type);
          params.append("property_id", this.property_id);
          params.append("info_content", this.value);
          this.axios
            .post(createInfoAPI, params)
            .then((response) => {
              if (!response.data || response.data.status !== "OK") {
                this.value = this.comment_before;
                this.input_show = false;
                this.$message({
                  type: "error",
                  offset: 7,
                  showClose: true,
                  message: this.property + "の保存に失敗しました。",
                });
                return;
              }
              this.$message({
                type: "success",
                offset: 7,
                showClose: true,
                message: this.property + "を更新しました",
              });
              this.$emit("update:info_content", this.value);
            })
            .catch(() => {});
        } 
        setTimeout(() => {
          this.comment_on = false;
        }, 300);
      }
    },
  },
  filters: {
    addComma(val) {
      if (val.match(/^[0-9]+$/)) {
        return Math.floor(val).toLocaleString();
      } else {
        return val;
      }
    },
  },
};
</script>

<style></style>
